module.exports = __webpack_public_path__ + "static/media/9DESA29.827e8a32.jpg";